// extracted by mini-css-extract-plugin
module.exports = {"PopoverContainer":"Tmfy-XBX8b8hUWQk7N6zg","PopoverTrigger":"Jdu_WIoCN5vknQ_UoZEji","SmileyIcon":"_2SrWWqbc1R_XuVq575wFMA","emojiButton":"_2DSZqZUKkSRf-y8jzjG-t0"};